/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const ToggleSkeleton = _ref => {
  let {
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const skeletonClassNames = cx(`${prefix}--toggle ${prefix}--toggle--skeleton`, className);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: skeletonClassNames
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--toggle__skeleton-circle`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--toggle__skeleton-rectangle`
  }));
};
ToggleSkeleton.propTypes = {
  'aria-label': PropTypes.string,
  className: PropTypes.string
};

export { ToggleSkeleton, ToggleSkeleton as default };
